export default __webpack_public_path__ + "static/media/banner12.c1f516d1.jpg";